import React from 'react';
import MetaTags from 'react-meta-tags';

import FullPageInformation from '~/components/FullPageInformation';
import FullScreenBackgroundDiv from './FullScreenBackgroundDiv';
import { RouteComponentProps } from '@reach/router';
import TEST_ID from './AccountCancelled.testid';

export const text = {
  pageTitle: 'Opgezegd',
  title: 'Account opgezegd',
  explanation:
    'Dit account is opgezegd. Neem contact op met onze helpdesk om toegang te herstellen.  Wij zijn te bereiken via de chat, op contact@dathuis.nl of per telefoon op 020 - 222 35 71.',
};

const AccountCancelled: React.FC<RouteComponentProps> = () => (
  <FullScreenBackgroundDiv>
    <MetaTags>
      <title>{text.pageTitle}</title>
    </MetaTags>
    <FullPageInformation
      dataTestid={TEST_ID.CONTAINER}
      title={text.title}
      explanation={text.explanation}
    />
  </FullScreenBackgroundDiv>
);

export default AccountCancelled;
